import React from "react";

export default function ModalLogin({
  visible,
  onClose,
  email,
  setEmail,
  password,
  setPassword,
  loginWithGoogle,
  loginWithEmail,
  isLogging = false,           // 👈 NUEVO: estado de carga
}) {
  if (!visible) return null;

  const handleGoogle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLogging) loginWithGoogle();
  };

  const handleEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLogging) loginWithEmail();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg">
        <h2 className="text-lg font-semibold text-sky-700 mb-4 text-center">
          Iniciar sesión
        </h2>

        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border p-2 w-full mb-2 rounded"
        />

        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2 w-full mb-4 rounded"
        />

        <div className="flex flex-col gap-2">
          <button
            type="button"                          // 👈 importante
            onClick={handleGoogle}
            disabled={isLogging}                   // 👈 evita doble click
            aria-busy={isLogging}
            className={`relative px-6 py-2 rounded-xl text-white font-semibold overflow-hidden shadow-md transition
              ${isLogging ? "bg-gray-400 cursor-not-allowed" : "bg-empresarial hover:bg-empresarialDark"}`}
          >
            {isLogging ? "Conectando..." : "Ingresar con Google"}
          </button>

          <button
            type="button"                          // 👈 importante
            onClick={handleEmail}
            disabled={isLogging}
            aria-busy={isLogging}
            className={`relative px-6 py-2 rounded-xl text-white font-semibold overflow-hidden shadow-md transition
              ${isLogging ? "bg-gray-400 cursor-not-allowed" : "bg-empresarial hover:bg-empresarialDark"}`}
          >
            {isLogging ? "Ingresando..." : "Iniciar con correo"}
          </button>

          <button
            type="button"
            onClick={onClose}
            className="text-sm text-gray-500 hover:underline"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
